enum RouteEnum {
  ORIGIN_CHARGE = "ORIGIN_CHARGE",
  FREIGHT = "FREIGHT",
  UNLOADING = "UNLOADING",
  CUSTOMS = "CUSTOMS",
  WAREHOUSING = "WAREHOUSING",
  DELIVERY = "DELIVERY",
  INSURANCE = "INSURANCE",
}

enum FlowOfGoodsEnum {
  IMPORT = "IMPORT",
  EXPORT = "EXPORT",
}

enum IncotermEnum {
  EXW = "EXW",
  FCA = "FCA",
  FAS = "FAS",
  FOB = "FOB",
  CFR = "CFR",
  CIF = "CIF",
  CFR_CIF = "CFR_CIF",
  CPT = "CPT",
  CIP = "CIP",
  DAT = "DAT",
  DAP = "DAP",
  DPU = "DPU",
  DDU = "DDU",
  DDP = "DDP",
}

// Incoterms route mapping
const INCOTERMS_ROUTE_MAPPING: Record<
  FlowOfGoodsEnum,
  Record<IncotermEnum, RouteEnum[]>
> = {
  [FlowOfGoodsEnum.IMPORT]: {
    [IncotermEnum.EXW]: [
      RouteEnum.ORIGIN_CHARGE,
      RouteEnum.FREIGHT,
      RouteEnum.UNLOADING,
      RouteEnum.CUSTOMS,
      RouteEnum.WAREHOUSING,
      RouteEnum.DELIVERY,
      RouteEnum.INSURANCE,
    ],
    [IncotermEnum.FCA]: [
      RouteEnum.ORIGIN_CHARGE,
      RouteEnum.FREIGHT,
      RouteEnum.UNLOADING,
      RouteEnum.CUSTOMS,
      RouteEnum.WAREHOUSING,
      RouteEnum.DELIVERY,
      RouteEnum.INSURANCE,
    ],
    [IncotermEnum.FAS]: [
      RouteEnum.ORIGIN_CHARGE,
      RouteEnum.FREIGHT,
      RouteEnum.UNLOADING,
      RouteEnum.CUSTOMS,
      RouteEnum.WAREHOUSING,
      RouteEnum.DELIVERY,
      RouteEnum.INSURANCE,
    ],
    [IncotermEnum.FOB]: [
      RouteEnum.FREIGHT,
      RouteEnum.UNLOADING,
      RouteEnum.CUSTOMS,
      RouteEnum.WAREHOUSING,
      RouteEnum.DELIVERY,
      RouteEnum.INSURANCE,
    ],
    [IncotermEnum.CFR]: [
      RouteEnum.UNLOADING,
      RouteEnum.CUSTOMS,
      RouteEnum.WAREHOUSING,
      RouteEnum.DELIVERY,
      RouteEnum.INSURANCE,
    ],
    [IncotermEnum.CIF]: [
      RouteEnum.UNLOADING,
      RouteEnum.CUSTOMS,
      RouteEnum.WAREHOUSING,
      RouteEnum.DELIVERY,
    ],
    [IncotermEnum.CFR_CIF]: [
      RouteEnum.UNLOADING,
      RouteEnum.CUSTOMS,
      RouteEnum.WAREHOUSING,
      RouteEnum.DELIVERY,
      RouteEnum.INSURANCE,
    ],
    [IncotermEnum.CPT]: [
      RouteEnum.UNLOADING,
      RouteEnum.CUSTOMS,
      RouteEnum.WAREHOUSING,
      RouteEnum.DELIVERY,
      RouteEnum.INSURANCE,
    ],
    [IncotermEnum.CIP]: [
      RouteEnum.UNLOADING,
      RouteEnum.CUSTOMS,
      RouteEnum.WAREHOUSING,
      RouteEnum.DELIVERY,
    ],
    [IncotermEnum.DAT]: [
      RouteEnum.CUSTOMS,
      RouteEnum.WAREHOUSING,
      RouteEnum.DELIVERY,
    ],
    [IncotermEnum.DAP]: [
      RouteEnum.CUSTOMS,
      RouteEnum.WAREHOUSING,
      RouteEnum.DELIVERY,
    ],
    [IncotermEnum.DPU]: [
      RouteEnum.CUSTOMS,
      RouteEnum.WAREHOUSING,
      RouteEnum.DELIVERY,
    ],
    [IncotermEnum.DDU]: [RouteEnum.CUSTOMS],
    [IncotermEnum.DDP]: [],
  },
  [FlowOfGoodsEnum.EXPORT]: {
    [IncotermEnum.EXW]: [],
    [IncotermEnum.FCA]: [],
    [IncotermEnum.FAS]: [],
    [IncotermEnum.FOB]: [RouteEnum.ORIGIN_CHARGE],
    [IncotermEnum.CFR]: [RouteEnum.ORIGIN_CHARGE, RouteEnum.FREIGHT],
    [IncotermEnum.CIF]: [
      RouteEnum.ORIGIN_CHARGE,
      RouteEnum.FREIGHT,
      RouteEnum.INSURANCE,
    ],
    [IncotermEnum.CFR_CIF]: [
      RouteEnum.ORIGIN_CHARGE,
      RouteEnum.FREIGHT,
      RouteEnum.INSURANCE,
    ],
    [IncotermEnum.CPT]: [
      RouteEnum.ORIGIN_CHARGE,
      RouteEnum.FREIGHT,
      RouteEnum.DELIVERY,
    ],
    [IncotermEnum.CIP]: [
      RouteEnum.ORIGIN_CHARGE,
      RouteEnum.FREIGHT,
      RouteEnum.DELIVERY,
      RouteEnum.INSURANCE,
    ],
    [IncotermEnum.DAT]: [
      RouteEnum.ORIGIN_CHARGE,
      RouteEnum.FREIGHT,
      RouteEnum.UNLOADING,
      RouteEnum.DELIVERY,
      RouteEnum.INSURANCE,
    ],
    [IncotermEnum.DAP]: [
      RouteEnum.ORIGIN_CHARGE,
      RouteEnum.FREIGHT,
      RouteEnum.UNLOADING,
      RouteEnum.DELIVERY,
      RouteEnum.INSURANCE,
    ],
    [IncotermEnum.DPU]: [
      RouteEnum.ORIGIN_CHARGE,
      RouteEnum.FREIGHT,
      RouteEnum.UNLOADING,
      RouteEnum.DELIVERY,
      RouteEnum.INSURANCE,
    ],
    [IncotermEnum.DDU]: [
      RouteEnum.ORIGIN_CHARGE,
      RouteEnum.FREIGHT,
      RouteEnum.UNLOADING,
      RouteEnum.DELIVERY,
      RouteEnum.INSURANCE,
    ],
    [IncotermEnum.DDP]: [
      RouteEnum.ORIGIN_CHARGE,
      RouteEnum.FREIGHT,
      RouteEnum.UNLOADING,
      RouteEnum.CUSTOMS,
      RouteEnum.DELIVERY,
      RouteEnum.INSURANCE,
    ],
  },
};

export { RouteEnum, FlowOfGoodsEnum, IncotermEnum, INCOTERMS_ROUTE_MAPPING };
